






























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import PendingForm from './pendingForm.vue'
import { throttle, download, hasValue } from '@/utils/util'
import {
	FIRST_VISIT,
	RESURVEY,
	MOTION,
	NEW_MOTION,
	REVISIT_TRACK_SUC,
	REVISIT_TRACK_FAIL,
} from '@/utils/const'
import RevisitApi from '@/api/revisit'
import { Empty } from 'ant-design-vue'
import MsgBoardDialog from '@/components/task/MsgBoardDialog.vue'

@Component({
	name: 'returnVisitCollectPendingInfo',
	components: {
		PageLayout,
		PendingForm,
		MsgBoardDialog,
	},
})
export default class PendingDetail extends Vue {
	private addLoading = false
	private failLoading = false
	private sucLoading = false
	private data: any = ''
	private id: string = ''
	private sucDisabled = false
	private failDisabled = false
	private FIRST_VISIT = FIRST_VISIT
	private showMsgBoard: boolean = false

	private get taskInfo() {
		return this.data.taskInfo || {}
	}

	private get taskList() {
		const taskInfo = this.data.taskInfo || {}
		let age: Number | null = null
		if (taskInfo.birthday) {
			age = new Date().getFullYear() - new Date(taskInfo.birthday).getFullYear()
		}
		return [
			{
				label: '初次探视订单号',
				value: taskInfo.orderNo,
			},
			{
				label: '派单公司',
				value: taskInfo.companyName,
			},
			{
				label: '伤者姓名',
				value: taskInfo.injuryName,
			},
			{
				label: '伤者年龄',
				value: hasValue(age) ? `${age}岁` : '',
			},
			{
				label: '诊断名称',
				value: taskInfo.diagnoseName,
			},
			{
				label: '治疗方式',
				value: this.$store.state.setting.treatWaysMap[taskInfo.treatWays],
			},
			{
				label: '实际所在医院',
				value: taskInfo.hospital,
			},
			{
				label: '实际所在科室',
				value: taskInfo.department,
			},
			{
				label: '伤者居住地址',
				value: taskInfo.livingAddress,
			},
			{
				label: '案件负责人姓名',
				value: taskInfo.contact,
			},
			{
				label: '案件负责人电话',
				value: taskInfo.contactPhone,
			},
		]
	}

	private get showForm() {
		return this.data.taskStatus >= '20'
	}

	private back() {
		this.$router.go(-1)
	}

	private cancelRevisit() {
		this.$confirm({
			title: '提示',
			content: '请确认是否取消认领？',
			onOk: () => {
				return RevisitApi.cancel(this.id).then(() => {
					this.$multiTab.closeCurrentPage()
					this.$multiTab.open('/returnVisit/returnVisitList')
				})
			},
			onCancel() {},
		})
	}

	private async startRevisit() {
		this.addLoading = true
		RevisitApi.begin(this.id)
			.then(() => {
				this.getDetail()
			})
			.catch(() => {
				this.switch2Detail()
			})
			.finally(() => {
				this.addLoading = false
			})
	}

	private setSucDisabled(disabled: boolean) {
		this.sucDisabled = disabled
	}

	private setFailDisabled(disabled: boolean) {
		this.failDisabled = disabled
	}

	private switch2Detail() {
		// 关闭当前可编辑页，换为仅查看页
		this.$multiTab.closeCurrentPage()
		this.$multiTab.open(`/returnVisit/pendingDetail/${this.id}`)
	}

	private saveForm(revisitStatus: string) {
		const formComponent: any = this.$refs.pendingForm
		formComponent
			.getForm()
			.then((values: any) => {
				// if (values.resurveyType && !values.addTaskValues) {
				// 	// 若需要新建复勘订单
				// 	this.$confirm({
				// 		title: '提示',
				// 		content: `您有【${
				// 			values.resurveyType === RESURVEY ? '住院复勘' : '活动度复勘'
				// 		}】未完成，请下单后提交`,
				// 		okText: '去下单',
				// 		onOk: () => {
				// 			formComponent.go2AddTask(values.resurveyType)
				// 		},
				// 		onCancel() {},
				// 	})
				// }

				values.id = this.id
				values.revisitStatus = revisitStatus
				if (values.resurveyType === RESURVEY && values.addTaskValues) {
					values.reviewOrder = {
						parentOrderId: this.data.taskInfo && this.data.taskInfo.orderId,
						...values.addTaskValues,
					}
				} else if (
					[MOTION, NEW_MOTION].includes(values.resurveyType) &&
					values.addTaskValues
				) {
					values.reviewActivityOrder = {
						parentOrderId: this.data.taskInfo && this.data.taskInfo.orderId,
						...values.addTaskValues,
					}
				}

				this.$confirm({
					title: '提示',
					content: `请确定是否提交【${this.$store.state.setting.revisitOptStatusMap[revisitStatus]}】，提交后不可修改？`,
					onCancel() {},
					onOk: () => {
						return RevisitApi.saveTrackTask(values).then((res: any) => {
							this.$message.success(res.message || '提交成功')
							this.switch2Detail()
						})
					},
				})
			})
			.catch((errors: any) => {
				const firstErr = errors && errors[Object.keys(errors)[0]]
				const message =
					(firstErr && firstErr.errors[0] && firstErr.errors[0].message) ||
					'请填写必填项'
				this.$message.error(message)
			})
			.finally(() => {
				this.sucLoading = false
				this.failLoading = false
			})
	}

	private revisitFail() {
		this.failLoading = true
		this.saveForm(REVISIT_TRACK_FAIL)
	}

	private revisitSuccess() {
		this.sucLoading = true
		this.saveForm(REVISIT_TRACK_SUC)
	}

	private getMessageMark() {
		return RevisitApi.getPendingDetail(this.id).then((res: any) => {
			const data = res.data
			this.$set(this.data, 'mark', data.mark)
		})
	}

	private getDetail() {
		return RevisitApi.getPendingDetail(this.id).then((res: any) => {
			this.data = res.data
			// 判断当前任务是否属于当前操作人
			if (
				this.data &&
				this.data.revisitor &&
				this.data.revisitor !== this.$store.state.user.userInfo.userId
			) {
				this.$message.error('该任务已被认领')
				this.switch2Detail()
			}
		})
	}

	private activated() {
		this.getMessageMark()
	}

	private created() {
		this.id = this.$ls.get('pendingTaskId')
		this.getDetail()
	}
}
